import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export type Faq = { q: string; a: string };

export default function FaqAccordion({ items }: { items: Faq[] }) {
  return (
    <Accordion type="single" collapsible className="w-full divide-y divide-border rounded-[24px] bg-white border border-border" style={{ boxShadow: "var(--shadow-card)" }}>
      {items.map((it, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-0 px-6 sm:px-8">
          <AccordionTrigger className="text-left text-[17px] sm:text-[18px] font-semibold text-navy hover:no-underline py-5">{it.q}</AccordionTrigger>
          <AccordionContent className="text-[15px] text-muted-foreground leading-relaxed pb-6">{it.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
